import React from 'react';

export const AlertTriangleIcon: React.FC = () => (
    <svg width='40' height='40' viewBox='160.5 99 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M196.717 129L183.383 105.667C183.093 105.154 182.671 104.727 182.162 104.43C181.652 104.133 181.073 103.977 180.483 103.977C179.894 103.977 179.315 104.133 178.805 104.43C178.296 104.727 177.874 105.154 177.583 105.667L164.25 129C163.956 129.509 163.802 130.087 163.803 130.674C163.805 131.262 163.961 131.839 164.257 132.346C164.554 132.854 164.979 133.274 165.489 133.565C166 133.855 166.579 134.005 167.167 134H193.833C194.418 133.999 194.993 133.845 195.499 133.552C196.005 133.259 196.425 132.839 196.718 132.332C197.01 131.825 197.163 131.251 197.163 130.666C197.163 130.081 197.009 129.507 196.717 129Z'
            stroke='currentColor'
            strokeWidth='3.66667'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M180.5 114V120.667'
            stroke='currentColor'
            strokeWidth='3.66667'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M180.5 127.333H180.517'
            stroke='currentColor'
            strokeWidth='3.66667'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
